app.controller('BrowsePropertyStyleController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    let validChoiceIDs = null;
    if ($scope.is_edit_mode) {
        $scope.navigation_ids = $scope.getEditNavigationIDs ? $scope.getEditNavigationIDs() : $scope.navigation_ids;
        validChoiceIDs = $scope.getEditChoiceIDs ? $scope.getEditChoiceIDs() : null;
    }

    $scope.style_model = $rootScope.factory.style.getModel($scope.navigation_ids);
    $scope.style_model.apiRequire();

    const styleRouteModel = $rootScope.factory.style_route.getModel($scope.navigation_ids);

    $scope.getStyleRouteChoiceList = function () {
        const choiceList = styleRouteModel.choiceList();
        for (let i = 0; i < choiceList.length; i++) {
            const choice = choiceList[i];
            if (!$scope.style_model.choices[choice.id] || (validChoiceIDs && !validChoiceIDs.includes(choice.id))) {
                choiceList.splice(i, 1);
                i--;
            }
        }
        return choiceList;
    }

    $scope.appearDisabled = function (choiceID) {
        const styleChoice = $scope.style_model.choices[choiceID];
        return !styleChoice || styleChoice.prominent_disabled;
    }

    $scope.isProminentDisabled = function (choiceID) {
        const styleChoice = $scope.style_model.choices[choiceID];
        return styleChoice && styleChoice.prominent_disabled;
    }


    $scope.hasCornerStrip = function (styleID) {
        const styleChoice = $scope.style_model.choices[styleID]
        return styleChoice && (styleChoice.limited_stock || styleChoice.promote_new);
    }

}])